import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@fluentui/react';
import { searchMarket } from '../api/prospectingApi';

export default function MarketSearch({ token, product, segments = [], onSelect }) {
  const [query, setQuery] = useState('');
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const requestRef = useRef(null);
  const segmentKey = Array.isArray(segments) ? segments.join(',') : '';

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed.length < 2) {
      setItems([]);
      setOpen(false);
      return undefined;
    }

    const timer = window.setTimeout(async () => {
      if (requestRef.current) requestRef.current.abort();
      const controller = new AbortController();
      requestRef.current = controller;
      setLoading(true);
      try {
        const response = await searchMarket(token, { product, q: trimmed, segments }, controller.signal);
        setItems(response?.items || []);
        setOpen(true);
      } catch (error) {
        if (error.name !== 'AbortError') {
          setItems([]);
          setOpen(false);
        }
      } finally {
        setLoading(false);
      }
    }, 260);

    return () => window.clearTimeout(timer);
  }, [query, token, product, segmentKey]);

  function choose(item) {
    setQuery('');
    setItems([]);
    setOpen(false);
    onSelect(item);
  }

  return (
    <div className="prospecting-search">
      <div className="prospecting-search-input-wrap">
        <Icon iconName="Search" />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onFocus={() => items.length && setOpen(true)}
          placeholder="Szukaj województwa, powiatu, gminy lub placówki"
          aria-label="Szukaj na rynku"
        />
        {loading ? <span className="prospecting-search-loader" /> : null}
      </div>
      {open ? (
        <div className="prospecting-search-results">
          {items.length ? items.map((item) => (
            <button type="button" key={`${item.kind}-${item.id}`} onClick={() => choose(item)}>
              <span className="prospecting-search-result-main">{item.name}</span>
              <span className="prospecting-search-result-meta">
                {item.kind === 'facility' ? `${item.registry_source || ''} ${item.registry_id || ''}`.trim() : ({ voivodeship: 'województwo', county: 'powiat', commune: 'gmina' }[item.scope] || item.scope)}
              </span>
            </button>
          )) : <div className="prospecting-search-empty">Brak wyników</div>}
        </div>
      ) : null}
    </div>
  );
}
